const e = "Stampcards", o = "Delivery Fee", n = "Other charges", a = "Cashback", t = "Payment methods", N = "Pay", r = "Tier", i = "Points", s = "Loyalty card", d = "Rewards", l = "Discount", Y = "Tip", c = "Total", u = "Subtotal", h = "Delivered", p = "Prepare", m = "Deliver", g = "En sala", y = "Takeaway", f = "Load more", k = "Save", v = "Name", L = "Surname", b = "Email", w = "Birthday", P = "Tags", T = "Gender", C = "Language", A = "Post code", q = "aaa", S = "Delivery", x = "Pickup", O = "Unknown", E = "Phone", R = "Today", B = "Tomorrow", _ = "Day", I = "Time", V = "Call", F = "Guest", W = "Sign in or sign up", M = "Uber", D = "Glovo", U = "Deliveroo", G = "Justeat", H = {
  "wallet.loading.errorTitle": "An error occurred",
  "wallet.loading.error": "Try downloading again",
  "wallet.loading.android.success": "Saved to Google Wallet",
  "wallet.loading.ios.success": "Saved to Apple Wallet",
  "wallet.loading.ios": "Loading in Apple Wallet",
  "wallet.loading.android": "Loading in Google Wallet",
  stampCards: e,
  "stampCard.complete": "Congratulations! You have completed all available cycles.",
  "stampCard.cycleEnd": "You have earned a new reward. Thank you for visiting us!",
  "stampCard.expired": "The card has expired",
  "stampCard.expirationLabel": "Expiration:",
  "userOrders.empty": "Your orders history is empty",
  "userOrders.info": "Select an order to view receipt details",
  deliveryFee: o,
  defaultFeeName: n,
  "kioskLanding.outOfOrder.title": "Out of Order",
  "kioskLanding.outOfOrder.subtitle": "Orders are not accepted at this time. Consult with a waiter to initiate an order.",
  "kioskLanding.language.title": "Select a language",
  "kioskLanding.service.title": "Where do you want your order?",
  "kioskLanding.service.takeaway": "Take away",
  "kioskLanding.service.dineIn": "Dine in",
  "kioskLanding.service.otherLanguages": "Other languages",
  "kioskLanding.inactive.title": "Do you want to continue the order?",
  "kioskLanding.inactive.prelude": "It will be automatically canceled",
  "kioskLanding.inactive.cancel": "Cancel order",
  "kioskLanding.inactive.continue": "Continue",
  "userGreetings.defaultUnAuthenticatedText": "Login in",
  "userGreetings.defaultAuthenticatedText": "Welcome, *|customer_name|*",
  "viewOrder.cashbackSpent": "{{denomination}} spent",
  "viewOrder.cashbackObtained": "{{denomination}} obtained",
  "orderRecord.anonOrderText": "Manual update",
  "myCashback.historyTitle": "{{denomination}} history",
  "myCashback.denomination": "Current {{denomination}}",
  cashback: a,
  "loginPage.prelude": "You must be logged to view this page",
  "loginPage.callToAction": "Click here to login",
  paymentMethods: t,
  "shopLanding.singleRestaurant.delivery.title": "When do you want your order?",
  "shopLanding.fetchAction.confirmation.accept": "Accept",
  "shopLanding.fetchAction.confirmation.cancel": "Cancel",
  "shopLanding.fetchAction.confirmation.title": "Are you sure?",
  "shopLanding.fetchAction.confirmation.body": "Please confirm this action",
  "shopLanding.fetchAction.2xx.title": "Success",
  "shopLanding.fetchAction.2xx": "{status} Success",
  "shopLanding.fetchAction.3xx.title": "Redirect",
  "shopLanding.fetchAction.3xx": "{status} Redirect",
  "shopLanding.fetchAction.error.title": "Error",
  "shopLanding.fetchAction.error": "{status} Error",
  "shopLanding.loadingRestaurants": "Preparing restaurants",
  "shopLanding.book.confirmation.bookingPolicy.label": "I consent to the processing of personal data",
  "shopLanding.book.error.text": "Something went wrong, please try again later.",
  "shopLanding.book.success.title": "Your booking has been completed",
  "shopLanding.book.success.text": "Your booking has been completed",
  "shopLanding.book.confirmation.submit": "Confirm",
  "shopLanding.book.confirmation.marketing.label": "I agree to receive brand promotions in my email",
  "shopLanding.book.confirmation.form.observations.placeholder": "Observations",
  "shopLanding.book.confirmation.form.observations.label": "Observations",
  "shopLanding.book.confirmation.form.area.placeholder": "Room 1",
  "shopLanding.book.confirmation.form.area.label": "Select the area",
  "shopLanding.book.confirmation.title": "Confirm your reservation:",
  "shopLanding.book.listing.submit": "Continue",
  "shopLanding.book.listing.title": "Book at:",
  "shopLanding.book.notMatch.text": "At this time we cannot offer you locations that match your preferences.",
  "shopLanding.book.notMatch.title": "No matching locations",
  "shopLanding.book.reservation.submit": "Find a restaurant",
  "shopLanding.book.reservation.title": "Make your reservation",
  "shopLanding.book.nOfPeople": "Nº of people",
  "shopLanding.book": "Book",
  "magiclink.tryAgain": "Retry",
  "magiclink.email.code.input": "Enter code",
  "magiclink.email.code.try.again": "Start again",
  "magiclink.email.code.continue": "Continue",
  "magiclink.email.title": "Enter the code we sent to your email",
  "magiclink.email.code.error": "Invalid code",
  "magiclink.email.content": "You will shortly receive an access link in your email. If you can't find it in your inbox, check your spam folder.",
  "payments.engine.7": "Pay later",
  "payments.engine.10": "Card, Apple pay or Google Pay",
  "payments.redirect.verifying": "Processing payment…",
  "payments.redirect.errorTitle": "The payment could not be completed.",
  "payments.redirect.error": "An error has occurred or the payment was cancelled. Please try again.",
  "payments.method.5": "Cash",
  "payments.method.4": "Bizum",
  "payments.method.3": "Apple pay",
  "payments.method.2": "Google pay",
  "payments.method.1": "Credit card",
  "shopLanding.legal.bookingPolicy": "Booking Policy",
  "shopLanding.legal.cookiesPolicy": "Cookies Policy",
  "shopLanding.legal.privacyPolicy": "Privacy Policy",
  "shopLanding.legal.termsAndConditions": "Terms and Conditions of Purchase",
  payLink: "Pay",
  "loyaltyCard.disabled": "The loyalty card is not available at the moment",
  tier: r,
  points: i,
  loyaltyCard: s,
  vouchers: d,
  "weekdays.short.monday": "Mon",
  "weekdays.short.tuesday": "Tues",
  "weekdays.short.wednesday": "Wed",
  "weekdays.short.thursday": "Thurs",
  "weekdays.short.friday": "Fri",
  "weekdays.short.saturday": "Sat",
  "weekdays.short.sunday": "Sun",
  "voucher.expiredBurnBtnText": "Offer not available",
  "voucher.burnBtnText": "Mark voucher as used",
  "voucher.terms.scheduleAllDays": "All Days",
  "voucher.terms.schedule": "Schedule",
  "voucher.terms.usesTimeframe.43200": "uses every 12 hours",
  "voucher.terms.usesTimeframe.86400": "daily uses",
  "voucher.terms.usesTimeframe.604800": "weekly uses",
  "voucher.terms.usesTimeframe.2592000": "monthly uses",
  "voucher.terms.maximum": "Maximum:",
  "voucher.terms.usesTotal": "Total uses",
  "voucher.terms.usesAndLimitations": "Uses & limitations",
  "terms.title": "Terms and Conditions",
  "voucher.error.noMoreUses": "No uses left",
  "voucher.error.outOfSchedule": "Out of schedule",
  "voucher.error.nextActivation": "Next activation",
  "addToWallet.android": "Google Wallet",
  "addToWallet.apple": "Add to Apple Wallet",
  "voucher.unlimited": "Unlimited",
  "voucher.validFromTitle": "Valid from",
  "voucher.validUntilTitle": "Valid until",
  "voucher.remainingUsesTitle": "Remaining uses",
  "voucher.pendingValidation": "Account pending verification",
  "voucher.verify": "Verify",
  "ticket.placed": "Placed",
  "ticket.followOrderBtn": "Follow your order",
  discount: l,
  tip: "Tip",
  total: c,
  subtotal: u,
  "order.status.unconfirmed": "Un-confirmed",
  "order.status.confirmed": "Confirmed",
  "order.status.ready": "Ready",
  "order.status.onroute": "On Route",
  "order.status.completed": "Completed",
  "order.status.cancelled": "Cancelled",
  order_delivered: h,
  order_preparation: p,
  order_deliver: m,
  dinein: g,
  takeaway: y,
  loadMore: f,
  "userOrders.heading": "Orders History",
  "userProfile.emptyTagsText": "You don't have any tags yet! Click here to add one",
  "gender.male": "Male",
  "gender.female": "Female",
  "gender.other": "Other",
  "gender.na": "N/A",
  "userProfile.editInfoHeading": "Edit your info",
  save: k,
  name: v,
  surname: L,
  email: b,
  birthday: w,
  tags: P,
  gender: T,
  language: C,
  postCode: A,
  "userProfile.navigation.profile": "Profile",
  "navigation.back": "Back",
  "shopLanding.address.error.unknown": "Something went wrong, please try again later",
  "shopLanding.address.error.locationTemporarilyUnavailable": "Sorry, this service is not available at the moment",
  "shopLanding.address.error.addressBothEmpty": "Please fill in the address and floor/door fields",
  "shopLanding.address.error.addressEmpty": "Please fill in the address field",
  "shopLanding.address.error.addressInfoEmpty": "Please, fill in the floor/door field",
  "shopLanding.singleRestaurant.eta.time": "{{time}} min",
  "shopLanding.singleRestaurant.eta": "Estimated preparation time:",
  "shopLanding.redirection.title": "Congratulations!",
  "shopLanding.redirection": "We are redirecting you so you can place your order",
  "shopLanding.noReach.title": "We don't cover your area",
  testDoNotTouch: "aaa",
  "userMenu.showProfile": "Show profile",
  "userMenu.logout": "Logout",
  "autocomplete.label": "Address",
  "autocomplete.placeholder": "Enter address including number",
  "autocomplete.geolocation": "Use my current location",
  "shopLanding.address.title": "Where do you order from?",
  "shopLanding.address.label": "Floor, door...",
  "shopLanding.address.placeholder": "Specify the address for delivery or enter a space if doesn't apply",
  "shopLanding.address.error.suspended": "Sorry, we cannot accept any more orders right now. Please try again in 20 minutes or pre-order for later.",
  "shopLanding.address.error.outOfRange": "Oops... right now we do not reach your area. Please try ordering for takeaway from your closest location.",
  "shopLanding.address.error.cannotDeliver": "Sorry, we are currently unable to deliver to your address. Please try ordering for takeaway from your closest location.",
  "shopLanding.address.error.invalidAddress": "Sorry, the address is invalid. Please check it and enter it again.",
  "shopLanding.address.error.missingStreet": "Please enter the street number",
  "shopLanding.address.error.orderThrough": "Or you can order through:",
  "shopLanding.selector.title": "Pick up your order at: ",
  "shopLanding.selector.laterBtn": "Pre-order",
  "shopLanding.selector.nowBtn": "Order now",
  "shopLanding.selector.doOrder": "Order",
  "shopLanding.datetime.title": "Pick a time:",
  "shopLanding.datetime.dayPlaceholder": "Select a a day..",
  "shopLanding.datetime.hourPlaceholder": "Select a time..",
  "shopLanding.datetime.cancelBtn": "Cancel",
  "shopLanding.datetime.programBtn": "Pre-order",
  "shopLanding.singleRestaurant.title": "This location will deliver your order:",
  delivery: S,
  pickup: x,
  unknown: O,
  phone: E,
  today: R,
  tomorrow: B,
  day: "Day",
  hour: I,
  call: V,
  guest: F,
  loginText: W,
  uber: M,
  glovo: D,
  deliveroo: U,
  justeat: G,
  "phoneVerification.title": "Verify your phone number",
  "phoneVerification.subtitle": "You will receive a code via SMS at {{phoneNumber}}",
  "phoneVerification.countdown": "If it doesn't arrive, you can request another code in {{time}}",
  "phoneVerification.resend": "Request another code",
  "phoneVerification.back": "Back",
  "phoneVerification.continue": "Continue",
  "phoneVerification.error": "Invalid code",
  "phoneVerification.error.invalidCode": "The code entered is not valid. Please try again.",
  "phoneVerification.error.expired": "The code has expired. Please request a new one.",
  "phoneVerification.error.alreadyUsed": "This code has already been used. Please request a new one.",
  "phoneVerification.error.attemptsExceeded": "Too many incorrect attempts. Please request a new code.",
  "phoneVerification.error.generic": "Something went wrong. Please try again.",
  "phoneInputForm.error.otpRequestCooldown": "Please wait before requesting a new code.",
  "phoneInputForm.error.otpRateLimit": "Too many requests. Please try again later.",
  "phoneInputForm.error.smsProviderError": "We couldn't send the SMS. Please try again.",
  "phoneInputForm.title": "Enter your phone number",
  "phoneInputForm.phoneLabel": "Phone",
  "phoneInputForm.back": "Back",
  "phoneInputForm.continue": "Continue",
  "duplicatePhoneError.title": "A user with this number already exists",
  "duplicatePhoneError.subtitle": "Your account's phone number is already registered by another user on the platform. Sign in with the associated email.",
  "duplicatePhoneError.back": "Go back"
};
export {
  w as birthday,
  V as call,
  a as cashback,
  _ as day,
  H as default,
  n as defaultFeeName,
  U as deliveroo,
  S as delivery,
  o as deliveryFee,
  g as dinein,
  l as discount,
  b as email,
  T as gender,
  D as glovo,
  F as guest,
  I as hour,
  G as justeat,
  C as language,
  f as loadMore,
  W as loginText,
  s as loyaltyCard,
  v as name,
  m as order_deliver,
  h as order_delivered,
  p as order_preparation,
  N as payLink,
  t as paymentMethods,
  E as phone,
  x as pickup,
  i as points,
  A as postCode,
  k as save,
  e as stampCards,
  u as subtotal,
  L as surname,
  P as tags,
  y as takeaway,
  q as testDoNotTouch,
  r as tier,
  Y as tip,
  R as today,
  B as tomorrow,
  c as total,
  M as uber,
  O as unknown,
  d as vouchers
};
//# sourceMappingURL=translation.json.js.map
